import autobind from "autobind-decorator";
import {extendObservable, observable} from "mobx";
import MatchSingleOddModel from "./singleOdd";

@autobind
class MatchOddsModel {
    @observable
    domestic = [];

    @observable
    international_additional = [];

    @observable
    international_basic = [];
    constructor(data) {
        this.domestic = data.domestic.map(
            (item) => new MatchSingleOddModel(item)
        );
        this.international_additional = data.international_additional.map(
            (item) => new MatchSingleOddModel(item)
        );
        this.international_basic = data.international_basic.map(
            (item) => new MatchSingleOddModel(item)
        );
    }
}

export default MatchOddsModel;